import { Directive, TemplateRef } from '@angular/core';
import { OptionComponent } from './option.component';

@Directive({ selector: 'ng-template[selectTrigger]', standalone: true })
export class SelectTriggerDirective {
  constructor(public templateRef: TemplateRef<{ $implicit: OptionComponent | null }>) {}
}
